import { IAnalyticSdr } from '../../../types/analyticsSdr';

/**
 * Analytics SDR for Mappings Domain.
 * This information should match the values in the SDR Excel file referenced here:
 * https://chalk.charter.com/display/ERSPM/FE+Analytics
 */

const siteSection = 'Mappings';

export const mappingsAnalytics: IAnalyticSdr = {
  mappingsTable: {
    siteSection,
    buttonClicks: {
      createMappingBtn: {
        itemClicked: 'Create Mapping',
      },
      editMappingMenuBtn: {
        itemClicked: 'Edit Mapping',
      },
      deleteMappingMenuBtn: {
        itemClicked: 'Delete Mapping',
      },
      deleteMappingDeleteBtn: {
        itemClicked: 'Delete',
      },
      deleteMappingCancelBtn: {
        itemClicked: 'Cancel',
      },
      deleteMappingCloseBtn: {
        itemClicked: 'Close',
      },
    },
  },
  createMappings: {
    siteSection,
    siteSubSection: 'Create Mapping',
    buttonClicks: {
      createRemoveRuleBtn: {
        itemClicked: 'Remove Rule',
      },
      createAddAnotherRuleBtn: {
        itemClicked: 'Add Another Rule',
      },
      createCancelBtn: {
        itemClicked: 'Cancel',
      },
      createSaveBtn: {
        itemClicked: 'Save',
      },
      createBackBtn: {
        itemClicked: 'Back',
      },
    },
    menuSelections: {
      createAccessPolicyMenu: {
        itemClicked: 'Access Policy',
      },
    },
  },
  editMappings: {
    siteSection,
    siteSubSection: 'Edit Mapping',
    buttonClicks: {
      editRemoveRuleBtn: {
        itemClicked: 'Remove Rule',
      },
      editAddAnotherRuleBtn: {
        itemClicked: 'Add Another Rule',
      },
      editCancelBtn: {
        itemClicked: 'Cancel',
      },
      editSaveBtn: {
        itemClicked: 'Save',
      },
      editBackBtn: {
        itemClicked: 'Back',
      },
    },
    menuSelections: {
      editAccessPolicyMenu: {
        itemClicked: 'Access Policy',
      },
    },
  },
};
